import React from 'react';

import { Tooltip } from 'app/seedly-component-library';
import { Calendar } from 'react-feather';
import { generateCredentialText } from 'app/utils/formatCredentials';
import isEmpty from 'lodash/isEmpty';
import values from 'lodash/values';
import dayjs from 'dayjs';
import { rewardOnboarding } from 'theme';
import Image from 'next/image';
import ProfileIconLink from './ProfileIconLink';

const ProfileDetail = props => {
  const { profile, defaultCredential, editProfileButton } = props;
  const { name, links } = profile;
  const shouldRenderCredential = !isEmpty(defaultCredential);
  const linksArr = values(links);

  const joinedAt = dayjs(profile.joinedAt).format('MMM ’YY');
  const { lifetimeSeeds } = profile;
  let seedText = '0';

  if (lifetimeSeeds >= 10000) {
    const thousands = lifetimeSeeds / 1000;
    const rounded = Math.round(thousands * 10) / 10;
    seedText = `${rounded}K`;
  } else {
    seedText = lifetimeSeeds?.toLocaleString();
  }

  return (
    <div className="card h-fit relative">
      <div className="flex w-full justify-between">
        <div className="flex flex-col gap-2 pt-0 lg:pt-7">
          <div className="flex items-center">
            <p className="text-[32px] font-bold">{name}</p>
            {profile.officialAccount && (
              <div className="text-white rounded-2xl bg-blue-500 px-3 py-1 ml-3 h-fit">
                Official Account
              </div>
            )}
          </div>
          {shouldRenderCredential && (
            <p>{generateCredentialText(defaultCredential)}</p>
          )}
          {!profile.officialAccount && (
            <div className="flex items-center gap-10">
              <div className="flex items-center gap-1">
                <Calendar size={16} />
                <p>Joined in {joinedAt}</p>
              </div>
              <Tooltip
                showToolTip
                placement="top"
                renderTriggerButton={() => {
                  return (
                    <div className="flex gap-1- items-center">
                      <Image
                        src={rewardOnboarding.seeds}
                        height={20}
                        width={20}
                      />
                      <p>{seedText} Lifetime seeds</p>
                    </div>
                  );
                }}
                renderToolTipBody={() => (
                  <div style={{ width: '180px', flexWrap: 'wrap' }}>
                    The total number of Seeds earned since joining Seedly.
                  </div>
                )}
              />
            </div>
          )}
          <div className="flex gap-4">
            {linksArr.map((link, index) => (
              <ProfileIconLink key={index} type={link.type} link={link.value} />
            ))}
          </div>
        </div>
        {editProfileButton}
      </div>
    </div>
  );
};

export default ProfileDetail;
